// Generated by ReScript, PLEASE EDIT WITH CARE

import * as React from "react";
import * as NLOrderWaypointVm from "./vm-mapper/NLOrderWaypointVm.bs.js";
import * as Accordion$Catalyst from "../../../../../../../../node_modules/@porterin/catalyst/src/components/generic/accordion/Accordion.bs.js";
import * as AccordionTypes$Catalyst from "../../../../../../../../node_modules/@porterin/catalyst/src/components/generic/accordion/AccordionTypes.bs.js";
import * as TableComponent$Catalyst from "../../../../../../../../node_modules/@porterin/catalyst/src/components/generic/table/TableComponent.bs.js";

function getTableColumnsSchema(param) {
  return {
          hd: {
            column: {
              TAG: /* Text */0,
              _0: "Landmark"
            },
            accessor: (function (waypoint) {
                return {
                        TAG: /* Text */0,
                        _0: waypoint.landmark
                      };
              })
          },
          tl: {
            hd: {
              column: {
                TAG: /* Text */0,
                _0: "Contact Name"
              },
              accessor: (function (waypoint) {
                  return {
                          TAG: /* Text */0,
                          _0: waypoint.contact_name
                        };
                })
            },
            tl: {
              hd: {
                column: {
                  TAG: /* Text */0,
                  _0: "Contact Number"
                },
                accessor: (function (waypoint) {
                    return {
                            TAG: /* Text */0,
                            _0: waypoint.contact_number
                          };
                  })
              },
              tl: /* [] */0
            }
          }
        };
}

function NLOrderWaypointInfo(Props) {
  var order = Props.order;
  var waypoints = NLOrderWaypointVm.getVm(order);
  return React.createElement(Accordion$Catalyst.make, {
              panels: {
                hd: AccordionTypes$Catalyst.make_props({
                      TAG: /* Text */0,
                      _0: "Waypoints"
                    }, undefined, undefined, waypoints ? React.createElement(TableComponent$Catalyst.make, {
                            columns: getTableColumnsSchema(undefined),
                            rowData: waypoints,
                            className: "c-nlo-table"
                          }) : "No waypoints exist", undefined),
                tl: /* [] */0
              },
              className: "c-nlo-accordion-cmp"
            });
}

var make = NLOrderWaypointInfo;

export {
  getTableColumnsSchema ,
  make ,
  
}
/* react Not a pure module */
